import React, { useContext, useMemo } from "react";
import { StoreContext } from "../../../Library/contexts";
import { Select } from "../../Atoms";

const ModelPicker = () => {
  const { constants, filters, setFilters } = useContext(StoreContext);
  const setModels = (m) => setFilters({ ...filters, models: m });

  const { options, selectAll } = useMemo(() => {
    const options = [];
    let total = 0;

    constants.models.forEach((model) => {
      total += (model.count || 0);
      options.push({ value: model.idx, label: `${model.nm} (${model.count || 0})` });
    });

    const selectAll = { label: `All Models (${total})` };

    return { options, selectAll };
  }, [ constants ]);

  return (
    <Select multi defaultValue={filters.models} selectAll={selectAll} onChange={setModels} options={options} width={200} />
  );
};

export default ModelPicker;
